import { createSelector } from '@reduxjs/toolkit'
import reduce from 'lodash/reduce'
import type { UserMap } from 'types/domain'

interface UsersRootState {
  users?: {
    all?: UserMap
  }
}

interface UserIdsProps {
  params?: {
    ids?: string[]
  }
}


const selectUsers = (state: Record<string, unknown>): UserMap => {
  const usersState = state as UsersRootState
  return usersState.users?.all || {}
}

const selectUserIds = (_state: Record<string, unknown>, props?: UserIdsProps): string[] | undefined => props?.params?.ids

export default createSelector(selectUsers, selectUserIds, (users, ids): UserMap => {
  if (!ids) {
    return users
  }
  return reduce(
    ids,
    (selected: UserMap, id: string) => {
      if (users[id]) {
        selected[id] = users[id]
      }
      return selected
    },
    {}
  )
})
